import CostDetailedReport from "../../components/Report/CostDetailedReport";
import "../PageCommon.css";
import "./Report.css";

const CostDetailedReportPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <div className="page__label">
          <CostDetailedReport />
        </div>
      </div>
    </div>
  );
}

export default CostDetailedReportPage;